import request from 'utils/request'

export const getTableData = data =>
  request().post('customer/finance/page', data)

// 模板下载
export const downloadTemp = () =>
  request().get('customer/finance/template/pull', { responseType: 'blob' })

// 上传报表
export const uploadFile = data =>
  request().post('customer/finance/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 批量导出
export const exportFile = data =>
  request().post('customer/finance/export', data, {
    responseType: 'arraybuffer',
  })

// 查看/对比财报详情
export const getFinanceView = data =>
  request().post('customer/finance/view', data)

// 查询批量导入评分卡财报数据记录
export const selectUnusual = id =>request().get(`customer/finance/selectUnusual/${id}`)
export const selectDynamic = id =>request().get(`customer/finance/selectDynamic/${id}`)